var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"computed"},[_c('button',{on:{"click":_vm.onAdd}},[_vm._v("+10")]),_c('div',[_vm._v("计算结果："+_vm._s(_vm.num3))])])}
var staticRenderFns = []

export { render, staticRenderFns }